import React, { useState } from "react";
import { MainGraph } from "./components/MainGraph";
import { AsideStats } from "./components/AsideStats";

export const ProgramMetrics = ({ locals }) => {
  const [groupedMetricsByProgram, setGroupedMetricsByProgram] = useState({});

  return (
    <main className="coaching-store">
      <MainGraph
        groupedMetricsByProgram={groupedMetricsByProgram}
        setGroupedMetricsByProgram={setGroupedMetricsByProgram}
        locals={locals}
      />
      <AsideStats
        groupedMetricsByProgram={groupedMetricsByProgram}
        locals={locals}
      />
    </main>
  );
};
